import {
  // GET BOOKING REVIEW LIST
  GET_BOOKING_REVIEW_LIST,
  GET_BOOKING_REVIEW_LIST_SUCCESS,
  GET_BOOKING_REVIEW_LIST_FAILED,

  // GET REVIEW OVERVIEW OF BOOKING REVIEW
  GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW,
  GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_SUCCESS,
  GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_FAILED,

  // GET BOOKING REVIEW DETAIL
  GET_BOOKING_REVIEW_DETAIL,
  GET_BOOKING_REVIEW_DETAIL_SUCCESS,
  GET_BOOKING_REVIEW_DETAIL_FAILED,

  // POST FEEDBACK BOOKING REVIEW
  POST_FEEDBACK_BOOKING_REVIEW,
  POST_FEEDBACK_BOOKING_REVIEW_SUCCESS,
  POST_FEEDBACK_BOOKING_REVIEW_FAILED,

  // UPDATE BOOKING REVIEW (INTRANET)
  UPDATE_BOOKING_REVIEW,
  UPDATE_BOOKING_REVIEW_SUCCESS,
  UPDATE_BOOKING_REVIEW_FAILED,

  // DELETE BOOKING REVIEW (INTRANET)
  DELETE_BOOKING_REVIEW,
  DELETE_BOOKING_REVIEW_SUCCESS,
  DELETE_BOOKING_REVIEW_FAILED,

  // UPDATE FEEDBACK BOOKING REVIEW
  UPDATE_FEEDBACK_BOOKING_REVIEW,
  UPDATE_FEEDBACK_BOOKING_REVIEW_SUCCESS,
  UPDATE_FEEDBACK_BOOKING_REVIEW_FAILED,

  // DELETE FEEDBACK BOOKING REVIEW
  DELETE_FEEDBACK_BOOKING_REVIEW,
  DELETE_FEEDBACK_BOOKING_REVIEW_SUCCESS,
  DELETE_FEEDBACK_BOOKING_REVIEW_FAILED,
} from './actionTypes';

const initialState = {
  isLoadingGetBookingReviewList: false,
  isLoadingGetReviewOverviewOfBookingReview: true,
  isLoadingGetBookingReviewDetail: false,
  isLoadingPostFeedbackBookingReview: false,
  isLoadingUpdateBookingReview: false,
  isLoadingDeleteBookingReview: false,
  isLoadingUpdateFeedbackBookingReview: false,
  isLoadingDeleteFeedbackBookingReview: false,

  bookingReviewList: [],
  totalBookingReviewList: 0,
  bookingReviewDetail: {},
  reviewOverviewOfBookingReview: {},
};

export default function bookingReview(state = initialState, action) {
  switch (action.type) {
    case GET_BOOKING_REVIEW_LIST:
      return {
        ...state,
        isLoadingGetBookingReviewList: true,
      };

    case GET_BOOKING_REVIEW_LIST_SUCCESS:
      return {
        ...state,
        isLoadingGetBookingReviewList: false,
        bookingReviewList: action.payload.data,
        totalBookingReviewList: action.payload.total,
      };

    case GET_BOOKING_REVIEW_LIST_FAILED:
      return {
        ...state,
        isLoadingGetReviewOverviewOfBookingReview: false,
      };

    case GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW:
      return {
        ...state,
        isLoadingGetReviewOverviewOfBookingReview: true,
      };

    case GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_SUCCESS:
      return {
        ...state,
        isLoadingGetReviewOverviewOfBookingReview: false,
        reviewOverviewOfBookingReview: action.payload,
      };

    case GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_FAILED:
      return {
        ...state,
        isLoadingGetBookingReviewList: false,
      };

    // GET BOOKING REVIEW DETAIL
    case GET_BOOKING_REVIEW_DETAIL:
      return {
        ...state,
        isLoadingGetBookingReviewDetail: true,
      };

    case GET_BOOKING_REVIEW_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingGetBookingReviewDetail: false,
        bookingReviewDetail: action.payload,
      };

    case GET_BOOKING_REVIEW_DETAIL_FAILED:
      return {
        ...state,
        isLoadingGetBookingReviewDetail: false,
      };

    // POST FEEDBACK BOOKING REVIEW
    case POST_FEEDBACK_BOOKING_REVIEW:
      return {
        ...state,
        isLoadingPostFeedbackBookingReview: true,
      };

    case POST_FEEDBACK_BOOKING_REVIEW_SUCCESS:
      return {
        ...state,
        isLoadingPostFeedbackBookingReview: false,
      };

    case POST_FEEDBACK_BOOKING_REVIEW_FAILED:
      return {
        ...state,
        isLoadingPostFeedbackBookingReview: false,
      };

    // UPDATE BOOKING REVIEW (INTRANET)
    case UPDATE_BOOKING_REVIEW:
      return {
        ...state,
        isLoadingUpdateBookingReview: true,
      };

    case UPDATE_BOOKING_REVIEW_SUCCESS:
    case UPDATE_BOOKING_REVIEW_FAILED:
      return {
        ...state,
        isLoadingUpdateBookingReview: false,
      };

    // DELETE BOOKING REVIEW (INTRANET)
    case DELETE_BOOKING_REVIEW:
      return {
        ...state,
        isLoadingDeleteBookingReview: true,
      };

    case DELETE_BOOKING_REVIEW_SUCCESS:
    case DELETE_BOOKING_REVIEW_FAILED:
      return {
        ...state,
        isLoadingDeleteBookingReview: false,
      };

    // UPDATE FEEDBACK BOOKING REVIEW
    case UPDATE_FEEDBACK_BOOKING_REVIEW:
      return {
        ...state,
        isLoadingUpdateFeedbackBookingReview: true,
      };

    case UPDATE_FEEDBACK_BOOKING_REVIEW_SUCCESS:
    case UPDATE_FEEDBACK_BOOKING_REVIEW_FAILED:
      return {
        ...state,
        isLoadingUpdateFeedbackBookingReview: false,
      };

    // DELETE FEEDBACK BOOKING REVIEW
    case DELETE_FEEDBACK_BOOKING_REVIEW:
      return {
        ...state,
        isLoadingDeleteFeedbackBookingReview: true,
      };

    case DELETE_FEEDBACK_BOOKING_REVIEW_SUCCESS:
    case DELETE_FEEDBACK_BOOKING_REVIEW_FAILED:
      return {
        ...state,
        isLoadingDeleteFeedbackBookingReview: false,
      };

    default:
      return state;
  }
}
